import {
  Avatar,
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Paper,
  Typography,
} from "@mui/material";
import { ClipConfigProps, ClipStepsControlProps } from "../../clip-menu";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { blue } from "@mui/material/colors";
import { makeStyles } from "@mui/styles";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import { useState } from "react";
import { DrawComponent } from "./draw-component";
import { UploadComponent } from "./upload-component";
import { BoundaryComponent } from "./boundary-component";
import React from "react";

const boundarySteps = [
  {
    stepName: "Upload",
    element: UploadComponent,
  },
  {
    stepName: "Draw",
    element: DrawComponent,
  },
  {
    stepName: "Boundary",
    element: BoundaryComponent,
  },
];

export const DefineBoundary = (
  props: ClipConfigProps & ClipStepsControlProps
) => {
  const classes = useStyles();
  const [component, setComponent] = useState("Draw");

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant="h5">Define Clip Boundary</Typography>
      <Box display="flex" flexDirection="row" gap={1}>
        <Card className={classes.typecard} variant="outlined">
          <CardActionArea onClick={() => setComponent("Upload")}>
            <CardContent className={classes.typecard}>
              <Avatar sx={{ bgcolor: blue[50] }}>
                <UploadFileIcon color="info" />
              </Avatar>
              <Typography variant="subtitle1">Upload</Typography>
              <Typography variant="body2" color="text.secondary">
                ZIP(10MB)
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
        <Card className={classes.typecard} variant="outlined">
          <CardActionArea onClick={() => setComponent("Draw")}>
            <CardContent className={classes.typecard}>
              <Avatar sx={{ bgcolor: blue[50] }}>
                <EditSharpIcon color="info" />
              </Avatar>
              <Typography variant="subtitle1">Draw</Typography>
              <Typography variant="body2" color="text.secondary">
                Bounding Box
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
        <Card className={classes.typecard} variant="outlined">
          <CardActionArea onClick={() => setComponent("Boundary")}>
            <CardContent className={classes.typecard}>
              <Avatar sx={{ bgcolor: blue[50] }}>
                <SearchSharpIcon color="info" />
              </Avatar>
              <Typography variant="subtitle1">Boundary</Typography>
              <Typography variant="body2" color="text.secondary">
                Search
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Box>
      <Box>
        {React.createElement(
          boundarySteps.filter((b) => b.stepName === component)[0].element,
          props
        )}
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme: any) => ({
  typecard: {
    width: "126px",
    height: "136px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
}));
